import { Reducer } from "redux";

import { AuctionAction, AuctionActionTypes, AuctionState } from "./types";

const initialState: AuctionState = {
  count: 0,
  items: [],
  itemsByIata: {},
  isLoading: false,
};

const reducer: Reducer<AuctionState, AuctionAction> = (state = initialState, action) => {
  switch (action.type) {
    case AuctionActionTypes.IATA_FETCH_REQUEST:
      return { ...state, isLoading: true };
    case AuctionActionTypes.TABLE_FETCH_REQUEST: {
      return { ...state, itemsByIata: {}, isLoading: true };
    }

    case AuctionActionTypes.IATA_FETCH_ERROR:
    case AuctionActionTypes.TABLE_FETCH_ERROR:
      return { ...state, isLoading: false };

    case AuctionActionTypes.TABLE_FETCH_SUCCESS: {
      const { count, results } = action.payload;
      return { ...state, count, isLoading: false, items: results };
    }

    case AuctionActionTypes.IATA_FETCH_SUCCESS: {
      const { iata, items } = action.payload;
      return {
        ...state,
        isLoading: false,
        itemsByIata: { ...state.itemsByIata, [iata]: items },
      };
    }

    default:
      return state;
  }
};

export default reducer;
